import { createDomain } from "effector";
import { FeedbackFormFields } from "./typedef";
import { defaultFeedbackFormState } from "./constants";
import { ChangeEvent } from "react";
import { mapFeedbackForm } from "@shared/mappers/mapFeedbackForm";
import { Rules } from "@models/common/rules";
import MailService from "../../../services/api/mail/MailService";

export const feedBackForm = createDomain("feedBackForm");

export const $formFields = feedBackForm.store<FeedbackFormFields>(defaultFeedbackFormState);
export const $formValidationErrors = feedBackForm.store<null | Partial<FeedbackFormFields>>(null);

export const updateFormField = feedBackForm.event<{
	event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>;
	field: keyof Omit<FeedbackFormFields, "phone">;
}>();

export const updateFormPhoneField = feedBackForm.event<string>();

export const handleFormSubmit = feedBackForm.event<FeedbackFormFields>();
export const validateFormFx = feedBackForm.effect<FeedbackFormFields, void, Partial<FeedbackFormFields>>(
	({ phone, name, email }) => {
		const isValidEmail = Rules.email().validator(email);
		const isValidPhone = Rules.russianPhone().validator(phone);
		const isValidName = Rules.name(true).validator(name);

		const result: Partial<FeedbackFormFields> = {};

		if (isValidName && isValidEmail && isValidPhone) {
			return;
		}

		if (!isValidEmail) result.email = Rules.email().errorText;

		if (!isValidPhone) result.phone = Rules.russianPhone().errorText;

		if (!isValidName) result.name = Rules.name().errorText;

		throw result;
	}
);

export const askQuestionFx = feedBackForm.effect(async (values: FeedbackFormFields) => {
	const feedBackFields = mapFeedbackForm(values);

	await MailService.sendContactForm(feedBackFields);
});
